// Helpers compartidos de la página CECP.

export const fmtCLP = (n) => `$${Math.round(Number(n) || 0).toLocaleString('es-CL')}`;

export const fmtDate = (s) => {
  if (!s) return '—';
  try { return new Date(s).toLocaleString('es-CL', { dateStyle: 'short', timeStyle: 'short' }); }
  catch { return s; }
};

export const fmtFecha = (s) => {
  if (!s) return '—';
  try { return new Date(s).toLocaleDateString('es-CL'); }
  catch { return s; }
};

export const normRut = (r) => (r || '').replace(/[.\- ]/g, '').toUpperCase();

/**
 * Devuelve 'verde' | 'amarillo' | 'rojo' según totales del matching.
 */
export function getSemaforo(item) {
  if (item?.estado === 'reenviado_corporativo') return 'gris';
  const t = item?.totales || {};
  const faltantesAnt = !!item?.tiene_faltantes_anteriores;
  if (faltantesAnt || (t.faltante || 0) > 0) return 'rojo';
  if ((t.match_parcial || 0) > 0) return 'amarillo';
  return 'verde';
}
